import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form'
import { ButtonGroup, Button } from 'reactstrap';
import { Course } from '../../models';
import Icon from '@mdi/react';
import {
    mdiBellCheckOutline,
    mdiBellOffOutline,
} from '@mdi/js';

import './AttendanceField.css';

const AttendanceField = ({ name, defaultValue, onValueChange, ...rest }) => {
    const { t } = useTranslation();
    const [val, setVal] = useState('none');

    const Component = ({input: {onChange, value}}) => {

        useEffect(() => {
            if (defaultValue)
                setVal(defaultValue);
        }, [name, defaultValue]);

        const changed = value => {
            onChange(value);
        }

        return (
            <ButtonGroup {...rest} >
                <Button color={value === Course.ATTENDANCE_PRESENT ? 'success' : 'dark'} onClick={e => changed(Course.ATTENDANCE_PRESENT)}>
                    <Icon path={mdiBellCheckOutline} size={1} />&nbsp;
                    {t('courses.attendance_present')}
                </Button>
                <Button className="ms-3" color={value === Course.ATTENDANCE_ABSENT ? 'danger' : 'dark'} onClick={e => changed(Course.ATTENDANCE_ABSENT)}>
                    <Icon path={mdiBellOffOutline} size={1} />&nbsp;
                    {t('courses.attendance_absent')}
                </Button>
            </ButtonGroup>
        );
    }

    return (
        <div className="AttendanceField">
            <Field name={ name } component={ Component } value={val} onChange={e => setVal(e.target.value)} className="form-control" />
        </div>
    );
}

export default AttendanceField;
